/**
 * Created by razial on 01.08.2023
 */

const BannerAd = function () {
    cleverapps.timeouts.setInterval(this.check.bind(this), BannerAd.CHECK_INTERVAL);

    connector.ads.on("sticky:start", this.onStart.bind(this));
    connector.ads.on("sticky:close", this.onClose.bind(this, true));
    connector.ads.on("error:showSticky", this.onError.bind(this));

    connector.ads.on("changeStatus", this.check.bind(this));

    connector.platform.on("gameplayStart", this.check.bind(this));
    connector.platform.on("gameplayStop", this.check.bind(this));

    this.errorTime = 0;
    this.closeTime = 0;
};

BannerAd.prototype.onError = function () {
    if (connector.ads.isAdBlockEnabled) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.ADS.AD_BLOCK_STICKY_FAIL);
    }

    this.errorTime = Date.now();

    this.bannerSize = undefined;
    cleverapps.resolution.checkResize();
};

BannerAd.prototype.canShow = function () {
    if (cleverapps.config.adminMode || cleverapps.config.editorMode) {
        return false;
    }

    if (this.errorTime + BannerAd.PAUSE_AFTER_ERROR > Date.now()) {
        return false;
    }

    if (this.closeTime + BannerAd.PAUSE_AFTER_CLOSE > Date.now()) {
        return false;
    }

    if (connector.platform.oneOf(connector.CRAZY) && !connector.platform.isGameplayActive()) {
        return false;
    }

    if (cleverapps.adsLimits.state(AdsLimits.TYPES.BANNER) !== AdsLimits.STATE_READY) {
        return false;
    }

    if (cleverapps.noAds && cleverapps.noAds.getState() === NoAds.STATE_ENABLED) {
        return false;
    }

    if (cleverapps.environment.isChatScene()
        || cleverapps.environment.isAtlasAnalyzerScene()
        || cleverapps.environment.isSceneWithPreview()
        || cleverapps.config.adminMode) {
        return false;
    }

    if (connector.info.isMobile && (cleverapps.resolution.isLandscapeOrientation() || cleverapps.config.orientation === "horizontal")) {
        return false;
    }

    if (connector.platform.oneOf(connector.TEST) && engine === "creator") {
        return false;
    }

    if (connector.platform.oneOf(connector.INSTANT)) {
        return connector.info.isInApp || cleverapps.config.name === "woodenblock";
    }

    return true;
};

BannerAd.prototype.onStart = function (bannerSize) {
    console.log("sticky.onStart", bannerSize);

    if (connector.ads.isAdBlockEnabled) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.ADS.AD_BLOCK_STICKY_SUCCESS);
    }

    if (connector.info.isInApp && cleverapps.config.debugMode) {
        cleverapps.notification.create(`Show sticky bannerSize: ${JSON.stringify(bannerSize)}`);
    }

    this.bannerSize = bannerSize;

    cleverapps.resolution.checkResize();

    cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.BANNER.SHOWN);
    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STATS.BANNER.DAU);

    this.check();
};

BannerAd.prototype.onClose = function () {
    console.log("sticky.onClose");

    this.bannerSize = undefined;
    this.closeTime = Date.now();

    cleverapps.resolution.checkResize();

    cleverapps.timeouts.setTimeout(() => this.check(), BannerAd.PAUSE_AFTER_CLOSE);

    cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.BANNER.HIDDEN);
};

BannerAd.prototype.getSafePadding = function () {
    if (this.bannerSize && this.canShow()) {
        return cc.padding({ bottom: this.bannerSize.height });
    }
};

BannerAd.prototype.check = function () {
    if (connector.info.isInApp && cleverapps.config.debugMode) {
        cleverapps.notification.create(`bannerAd check ${this.canShow()}`);
    }

    if (this.canShow()) {
        console.log("sticky.show");

        connector.ads.showStickyCallback();
    } else {
        console.log("sticky.close");

        connector.ads.closeStickyCallback();
    }
};

BannerAd.prototype.doResize = cleverapps.accumulate(300, function () {
    this.check();
});

BannerAd.prototype.getGlobalBoundingBox = function () {
    const bgSize = cleverapps.resolution.getBgSize();

    if (connector.ads.isStickyPlaying && this.bannerSize) {
        const width = this.bannerSize.width
            ? Math.round(bgSize.width * this.bannerSize.width / cleverapps.resolution.getFrameSize().width)
            : bgSize.width;
        return cc.rect(bgSize.width / 2 - width / 2, 0, width, this.bannerSize.height);
    }
};

BannerAd.CHECK_INTERVAL = cleverapps.parseInterval("1 minute");
BannerAd.PAUSE_AFTER_CLOSE = cleverapps.parseInterval("30 seconds");
BannerAd.PAUSE_AFTER_ERROR = cleverapps.parseInterval(cleverapps.config.debugMode ? "15 seconds" : "5 minutes");
